import React, { FC }    from "react";
import { Button, Icon } from "semantic-ui-react";

type Props = {
  onClick: () => void;
  label: string;
}

const EditButton: FC<Props> = ({onClick, label}) => (
  <>
    <Button
      icon
      labelPosition="left"
      onClick={ () => onClick() }
    >
      <Icon name="edit"/>
      { label }
    </Button>
  </>
);

export default EditButton;